import { Component, OnInit,ViewChild } from '@angular/core';
import { AveriasService } from '../servicios/averias.service';
import { Componente } from '../entidades/entidades.component';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { SelectItem } from 'primeng/api';
import {SnackBarComponent} from '../snack-bar/snack-bar.component';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Column, GridOption, Formatters, AngularGridInstance, DelimiterType, FileType, ExtensionName, Formatter, FieldType, Editors } from 'angular-slickgrid';
import { DatePipe } from '@angular/common';
import { PerfilesUsuarioService } from '../servicios/perfiles-usuario.service';
import { from } from 'rxjs';
import { filter } from 'rxjs/operators';
import { AnalyticsService } from '../servicios/analytics.service';
//import {SharedModule} from '../shared/shared.module';
import { FormsModule } from '@angular/forms'; // Para [(ngModel)]
import { DropdownModule } from 'primeng/dropdown'; // Para <p-dropdown>
import { NbIconModule } from '@nebular/theme'; // Para <nb-icon>
import { CommonModule } from '@angular/common';
import { SpinnerComponent } from '../spinner/spinner.component';
import { NbCardModule } from '@nebular/theme';
import { MatCardModule } from '@angular/material/card';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { AngularSlickgridModule } from 'angular-slickgrid';
import { NbTabsetModule } from '@nebular/theme';
import { NbCheckboxModule } from '@nebular/theme';
import { AgGridAngular } from 'ag-grid-angular'; // Angular Data Grid Component
import type { ColDef } from 'ag-grid-community'; // Column Definition Type Interface
import { GridApi, GridReadyEvent } from 'ag-grid-community';
import { Dropdown } from 'primeng/dropdown';



import * as XLSX from 'xlsx';
import * as FileSaver from 'file-saver';

@Component({
    selector: 'app-componente',
    templateUrl: './componente.component.html',
    styleUrls: ['./componente.component.css'],
    standalone: true,
    imports: [FormsModule,CommonModule,NbCardModule,NbIconModule,DropdownModule,
      MatCardModule,MatFormFieldModule,MatInputModule,SpinnerComponent,AngularSlickgridModule,
      NbTabsetModule, AgGridAngular, NbCheckboxModule],

    providers: [DatePipe],
})
export class ComponenteComponent implements OnInit {
  durationInSeconds = 3;
  firstForm: UntypedFormGroup;
  checked = false;
  componente: SelectItem[];
  componenteOK = false;
  IdComponente: number;
  showComponente = false
  ComponenteProcesado;
  descripcionComponente;
  descripcionBreve;
  codigoExterno;
  componenteCompleto;
  descripcionBreveEditar;
  descripcionComponenteEditar;
  codigoExternoEditar;
  cuadrante = false;
  zona = false;
  tieneZonaModificar;
  tieneCuadranteModificar;
  tieneZonaAlta: boolean = false;
  tieneCuadranteAlta;
  zonaCuadranteCompleta;
  zonaCuadrante;
  zonaCuadranteSeleccionado;
  zonaCuadranteSeleccionadoAlta;
  showZonaCuadrante = false;
  IdZonaCuadrante: number;
  ZonaCuadranteOk = false
  datasetComponente: any[] = [];
  datasetComponenteConsulta: any[] = [];
  datasetComponenteModificar: any[] = [];
  angularGridComponente: AngularGridInstance;
  angularGridComponenteConsulta: AngularGridInstance;
  angularGridComponenteModificar: AngularGridInstance;
  showSpinner = false;
  columnDefinitionsComponente: ColDef[];//Column[];
  columnDefinitionsComponenteModificar: ColDef[];//Column[];
  gridOptionsComponente: GridOption;
  gridOptionsComponenteModificar: GridOption;
  columnDefinitionsComponenteConsulta: ColDef[];//Column[];
  gridOptionsComponenteConsulta: GridOption;
  gridObjComponente: any;
  showGrilla = false;
  showGrillaConsulta = false;
  showSpinnerConsulta = false;
  showSpinnerGuardar = false;
  showSpinnerModificar = false;
  idCliente:number;
  eliminar = false;
  eliminarSeleccionado;
  showSpinnerModificarGrilla = false;
  showGrillaModificar = false;

  @ViewChild('grilla1') grilla1!: AgGridAngular;
  @ViewChild('grilla2') grilla2!: AgGridAngular;
  @ViewChild('grilla3') grilla3!: AgGridAngular;
  @ViewChild('dropdown') dropdown!: Dropdown;

  constructor(private fb: UntypedFormBuilder, private AveriasService: AveriasService, 
    private _snackBar: MatSnackBar, private dateFormatter: DatePipe, 
    public usersRol: PerfilesUsuarioService, private svcAnalytics: AnalyticsService) { }
  ngOnInit(): void {
    this.idCliente = Number(localStorage.getItem('idCliente'));
    this.firstForm = this.fb.group({
      firstCtrl: ['-', Validators.required],
    });
    this.consultarZonaCuadrante();
    this.svcAnalytics.setAnalyticsPageView();
  }

  ngAfterViewInit():void {

  }
  onChangeTab(event){
    if(event.tabTitle == "Alta"){
      this.consultarComponente();
    }
    if(event.tabTitle == "Consulta"){
      this.consultarComponenteConsulta();
    }
    if(event.tabTitle == "Modificación"){
      this.consultarComponenteModificar();
    }
  }

  toggleEliminar(eliminar: boolean) {
    this.eliminar = eliminar;
  }
  toggleZona(zona: boolean) {
    this.tieneZonaModificar = zona;
  }
  toggleCuadrante(cuadrante: boolean) {
    this.tieneCuadranteModificar = cuadrante;
  }
  openSnackBar(mensaje: string) {
    this._snackBar.openFromComponent(SnackBarComponent, {
      duration: this.durationInSeconds * 1000,
      data: mensaje
    });
  }
  consultarComponente() {
    this.showSpinner = true;
    this.showGrilla = false;
    this.AveriasService.getComponente(this.idCliente).subscribe(
      data => {
        this.componenteCompleto = data;
        this.componente = this.insertarComponente(data);
        this.traerDatosComponente();
        this.fillGrillaComponente();
      });
  }
  consultarComponenteConsulta() {
    this.showSpinnerConsulta = true;
    this.showGrillaConsulta = false;
    this.AveriasService.getComponente(this.idCliente).subscribe(
      data => {
        this.componenteCompleto = data;
        this.traerDatosComponenteConsulta();
        this.fillGrillaComponenteConsulta();
      });
  }
  consultarComponenteModificar() {
    this.showSpinnerModificarGrilla = true;
    this.showGrillaModificar = false;
    this.AveriasService.getComponente(this.idCliente).subscribe(
      data => {
        this.componenteCompleto = data;
        this.componente = this.insertarComponente(data);
        this.traerDatosComponenteModificar();
        this.fillGrillaComponenteModificar();
      });
  }
  insertarComponente(armarComponente) {
    let averiasComponente: Array<any> = [];
    armarComponente.content.forEach(element => {
      averiasComponente.push({
        label: element.descripcion,
        value: element.id,
      });
    })
    return averiasComponente;
  };
  capturarComponente(event) {
    this.IdComponente = event;
    this.componenteOK = true;
  }
  consultarZonaCuadrante() {
    this.AveriasService.getZonaCuadrante(this.idCliente).subscribe(
      data => {
        this.zonaCuadranteCompleta = data;
        this.zonaCuadrante = this.insertarZonaCuadrante(data);
        this.showZonaCuadrante = true;

      });
  }
  insertarZonaCuadrante(armarZonaCuadrante) {
    let averiasZonaCuadrante: Array<any> = [];
    armarZonaCuadrante.content.forEach(element => {
      averiasZonaCuadrante.push({
        label: element.descripcion,
        value: element.id,
      });
    })
    return averiasZonaCuadrante;
  };
  capturarZonaCuadrante(event) {
    this.IdZonaCuadrante = event;
    this.ZonaCuadranteOk = true;
  }
  altaComponente() {
    let componente: Componente;

    if (this.descripcionComponente == null || this.descripcionComponente == "") {
      this.openSnackBar("Debe Completar la Descripción ❌");
    } else if (this.descripcionBreve == null || this.descripcionBreve == "") {
      this.openSnackBar("Debe Completar la Descripción Breve ❌");
    } else if (this.codigoExterno == null || this.codigoExterno == "") {
      this.openSnackBar("Debe Completar el Código Externo ❌");
    } else if (this.tieneZonaAlta && (this.zonaCuadranteSeleccionadoAlta == null || this.zonaCuadranteSeleccionadoAlta == '')) {
        this.openSnackBar("Debe seleccionar una Zona Cuadrante");
      } else {
      componente = {
        descripcion: this.descripcionComponente,
        descripcionAbreviada: this.descripcionBreve,
        codigoExterno: this.codigoExterno,
        idCliente: this.idCliente,
        tieneZona: this.tieneZonaAlta,
        tieneCuadrante: this.tieneZonaAlta,
        idZonaCuadrante: this.tieneZonaAlta == false ? null : this.zonaCuadranteSeleccionadoAlta
      }
      this.showSpinnerGuardar = true;
      this.AveriasService.postComponente(componente).subscribe(data => {
        if(data["status"] == 201){
          this.openSnackBar('Los cambios se han guardado correctamente');
           } else {
            this.openSnackBar('Ha ocurrido un error al guardarse los datos');
          }
        this.descripcionComponente = '';
        this.descripcionBreve = '';
        this.codigoExterno = '';
        this.tieneZonaAlta = false;
        this.tieneCuadranteAlta = false;
        this.consultarComponente();
        this.showSpinnerGuardar = false;
      })
    }
  }
  modificarComponente () {
    let componente: Componente ; 
    if (this.eliminar) {
      this.AveriasService.deleteComponente(this.ComponenteProcesado).subscribe(data => {
        if (data["status"] == 204) {
          this.openSnackBar('Los datos se han eliminado correctamente');
          this.descripcionComponenteEditar = '';
          this.descripcionBreveEditar = '';
          this.codigoExternoEditar = '';
          this.ComponenteProcesado = '';
          this.tieneCuadranteModificar = false;
          this.tieneZonaModificar = false;
          this.eliminarSeleccionado = false;
        } else {
          this.openSnackBar('Ha ocurrido un error al borrar los datos');
        }
        this.eliminarSeleccionado = false;
        this.eliminar = false;
        this.consultarComponenteModificar();
      })
    } else {

      if (this.descripcionComponenteEditar == null || this.descripcionComponenteEditar == "") {
        this.openSnackBar("Debe Completar la Descripción ❌");
      } else if (this.descripcionBreveEditar == null || this.descripcionBreveEditar == "") {
        this.openSnackBar("Debe Completar la Descripción Breve ❌");
      } else if (this.codigoExternoEditar == null || this.codigoExternoEditar == "") {
        this.openSnackBar("Debe Completar el Código Externo ❌");
      } else {
        this.showSpinnerModificar = true;
        componente = {
          descripcion: this.descripcionComponenteEditar,
          descripcionAbreviada: this.descripcionBreveEditar,
          codigoExterno: this.codigoExternoEditar,
          idCliente: this.idCliente,
          tieneZona: this.tieneZonaModificar,
          tieneCuadrante: this.tieneZonaModificar,
          idZonaCuadrante: this.tieneZonaModificar ==false ? null : this.zonaCuadranteSeleccionado
      }
      this.AveriasService.putComponente(this.ComponenteProcesado, componente).subscribe(data =>{
        if(data["status"] == 200){
          this.openSnackBar('Los cambios se han guardado correctamente');
           } else {
            this.openSnackBar('Ha ocurrido un error al guardarse los datos');
          }
        this.showSpinnerModificar = false;
        this.eliminarSeleccionado = false;
        this.eliminar = false;
        this.consultarComponenteModificar();
      })
      this.descripcionComponenteEditar = '';
      this.descripcionBreveEditar = '';
      this.codigoExternoEditar = '';
      this.ComponenteProcesado = '';
      this.tieneCuadranteModificar = false;
      this.tieneZonaModificar = false;
      this.eliminarSeleccionado = false;
      
    }
    }
  }
  obtenerDescripcionDropdown(IdComponente: number) {
    let resp = this.componenteCompleto.content.find(n => n['id'] == IdComponente);
    this.descripcionBreveEditar = resp['descripcionAbreviada'];
    this.descripcionComponenteEditar = resp['descripcion'];
    this.codigoExternoEditar = resp['codigoExterno'];
    this.tieneZonaModificar = resp['tieneZona'];
    this.zonaCuadranteSeleccionado = resp['tieneZona'] == true? resp.zonaCuadrante.id : "";
    this.eliminarSeleccionado = false;
  }
  //Grilla Componente
  traerDatosComponente() {
    let DatosComponente = this.componenteCompleto['content'];
    let mockDataset : any = [];
    for (let i = 0; i < DatosComponente.length; i++) {
      mockDataset.push({
        id: DatosComponente[i]["id"],
        Descripcion: DatosComponente[i]["descripcion"],
        DescripcionAbreviada: DatosComponente[i]["descripcionAbreviada"],
        Codigo: DatosComponente[i]["codigoExterno"],
      });
    }
    this.datasetComponente  = mockDataset;
    this.showSpinner = false;
    this.showGrilla = true;
  }
  traerDatosComponenteConsulta() {
    let DatosComponente = this.componenteCompleto['content'];
    let mockDataset : any = [];
    for (let i = 0; i < DatosComponente.length; i++) {
      mockDataset.push({
        id: DatosComponente[i]["id"],
        Descripcion: DatosComponente[i]["descripcion"],
        DescripcionAbreviada: DatosComponente[i]["descripcionAbreviada"],
        Codigo: DatosComponente[i]["codigoExterno"],
        ZonaCuadrante: DatosComponente[i].zonaCuadrante != null ? DatosComponente[i].zonaCuadrante["descripcion"] : '',
      });
    }
    this.datasetComponenteConsulta  = mockDataset;
    this.showSpinnerConsulta = false;
    this.showGrillaConsulta = true;
  }

  traerDatosComponenteModificar() {
    let DatosComponente = this.componenteCompleto['content'];
    let mockDataset : any = [];
    for (let i = 0; i < DatosComponente.length; i++) {
      mockDataset.push({
        id: DatosComponente[i]["id"],
        Descripcion: DatosComponente[i]["descripcion"],
        DescripcionAbreviada: DatosComponente[i]["descripcionAbreviada"],
        Codigo: DatosComponente[i]["codigoExterno"],
      });
    }
    this.datasetComponenteModificar  = mockDataset;
    this.showSpinnerModificarGrilla = false;
    this.showGrillaModificar = true;
  }
  fillGrillaComponente() {
    this.columnDefinitionsComponente = [
      { //id: 'Descripcion', 
        headerName: 'Descripción', field: 'Descripcion', sortable: true, filter: true, floatingFilter: true, minWidth: 100, width: 100},
      { //id: 'DescripcionAbreviada', 
        headerName: 'Descripción Abreviada', field: 'DescripcionAbreviada', sortable: true, filter: true, floatingFilter: true, minWidth: 100, width: 100},
      { //id: 'Codigo', 
        headerName: 'Código', field: 'Codigo', sortable: true, filter: true, floatingFilter: true, minWidth: 40, width: 40},
    ];
    this.gridOptionsComponente = {
      enableAutoResize: true,
      enableGridMenu : false,
      enableSorting: true,
      enableCellNavigation: true,
      enableCellMenu: true,
      enableCheckboxSelector: false,
      enableRowSelection: false,
      enableFiltering: true,
      enablePagination: false,
      rowSelectionOptions: {selectActiveRow: false}
    };
  }
  fillGrillaComponenteConsulta() {
    this.columnDefinitionsComponenteConsulta = [
      { //id: 'Descripcion', 
        headerName: 'Descripción', field: 'Descripcion', sortable: true, filter: true, floatingFilter: true, minWidth: 100, width: 100},
      { //id: 'DescripcionAbreviada', 
        headerName: 'Descripción Abreviada', field: 'DescripcionAbreviada', sortable: true, filter: true, floatingFilter: true, minWidth: 100, width: 100},
      { //id: 'Codigo', 
        headerName: 'Código', field: 'Codigo', sortable: true, filter: true, floatingFilter: true, minWidth: 40, width: 40},
      { //id: 'ZonaCuadrante', 
        headerName: 'Zona Cuadrante', field: 'ZonaCuadrante', sortable: true, filter: true, floatingFilter: true, minWidth: 40, width: 40},

    ];
    this.gridOptionsComponenteConsulta = {
      enableExcelExport: true,
      enableAutoResize: true,
      enableGridMenu : false,
      enableSorting: true,
      enableCellNavigation: true,
      enableCellMenu: true,
      enableCheckboxSelector: false,
      enableRowSelection: false,
      enableFiltering: true,
      enablePagination: false,
      rowSelectionOptions: {selectActiveRow: false},
    };
  }
  fillGrillaComponenteModificar() {
    this.columnDefinitionsComponenteModificar = [
      { //id: 'Descripcion', 
        headerName: 'Descripción', field: 'Descripcion', sortable: true, filter: true, floatingFilter: true, minWidth: 210, width: 210},
      { //id: 'DescripcionAbreviada', 
        headerName: 'Descripción Abreviada', field: 'DescripcionAbreviada', sortable: true, filter: true, floatingFilter: true, minWidth: 210, width: 210},
      { //id: 'Codigo', 
        headerName: 'Código', field: 'Codigo', sortable: true, filter: true, floatingFilter: true, minWidth: 120, width: 120},
    ];
    this.gridOptionsComponenteModificar = {
      enableAutoResize: true,
      enableGridMenu : false,
      enableSorting: true,
      enableCellNavigation: true,
      enableCellMenu: true,
      enableCheckboxSelector: false,
      enableRowSelection: false,
      enableFiltering: true,
      enablePagination: false,
      rowSelectionOptions: {selectActiveRow: false}
    };
  }
  angularGridReadyComponente(angularGrid: AngularGridInstance){
    this.angularGridComponente = angularGrid;
    this.angularGridComponente.resizerService.pauseResizer(false)
  }
  angularGridReadyComponenteConsulta(angularGrid: AngularGridInstance){
    this.angularGridComponenteConsulta = angularGrid;
    this.angularGridComponenteConsulta.resizerService.pauseResizer(false)
  }
  angularGridReadyComponenteModificar(angularGrid: AngularGridInstance){
    this.angularGridComponenteModificar = angularGrid;
    this.angularGridComponenteModificar.resizerService.pauseResizer(false)
  }

    exportToExcelComponente(): void {
        const rowData: any[] = [];
       const columnasVisibles = this.grilla1.api.getAllDisplayedColumns();
      
        // Obtener solo las filas visibles (después de filtros y orden)
        this.grilla1.api.forEachNodeAfterFilterAndSort((node) => {
          if (node.data) {
            const filaFiltrada: any = {};
      
            // Solo columnas visibles
            columnasVisibles.forEach(col => {
              const campo = col.getColDef().field;
              if (campo && campo!='action') {
                filaFiltrada[campo] = node.data[campo];
              }
            });
            rowData.push(filaFiltrada);
          }
        });
      
        if (rowData.length === 0) {
          console.warn('No hay datos para exportar');
          return;
        }
      
        const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(rowData);
        const workbook: XLSX.WorkBook = {
          Sheets: { 'Componente': worksheet },
          SheetNames: ['Componente']
        };
      
        const excelBuffer: any = XLSX.write(workbook, {
          bookType: 'xlsx',
          type: 'array'
        });
      
        const blob = new Blob([excelBuffer], { type: 'application/octet-stream' });
        FileSaver.saveAs(blob, 'Componente_' + this.dateFormatter.transform(new Date(), 'dd-MM-yyyy') + '.xlsx');
      }
  onGridReady(params: GridReadyEvent): void {
    this.grilla1.api.sizeColumnsToFit();
    this.grilla2.api.sizeColumnsToFit();
    this.grilla3.api.sizeColumnsToFit();
  
  }
  
}


